import Guid from '@/app/utils/guid'
import Entity from '@/common/models/entity'
import Candidate from './candidate'
import Evaluation from './evaluation'
import Judge from './judge'

export default class Rating extends Entity {
  public id = Guid.empty()
  public evaluationId = Guid.empty()
  public evaluation = new Evaluation()
  public candidateId = Guid.empty()
  public candidate = new Candidate()
  public judgeId = Guid.empty()
  public judge = new Judge()
  public competenceId = Guid.empty()
  public competenceTitle = ''
  public competenceDescription = ''
  public score?: number
  public targetValue?: number
}
